export default {
    isFormOpen: state => state.formIsOpen,
    isPrepaymentInvoiceFormOpen: state => state.prepaymentInvoiceFormIsOpen,
    isGridOpen: state => state.gridIsOpen,

    getDataTableOptions: state => state.dataTableOptions,
    getActions: state => state.actions,
    getSearchFields: state => state.searchFields,
    getFormActions: state => state.formActions,
    getRowActions: state => state.rowActions,

    getSelectPartnerHeaderFields: state => state.selectPartnerHeaderFields,
    getSelectPartnerRowActions: state => state.selectPartnerRowActions,
    getSelectPartnerDataTableOptions: state => state.selectPartnerDataTableOptions,
    getPatientCompanyHeaderFields: state => state.patientCompanyHeaderFields,
    getPatientFormActions: state => state.patientFormActions,
    getPaymentStatusFormActions: state => state.paymentStatusFormActions,
    getCustomerFormActions: state => state.customerFormActions,
    getCustomerHeaderFields: state => state.customerHeaderFields,
    getSelectCustomerRowActions: state => state.selectCustomerRowActions,
    getSelectCustomerDataTableOptions: state => state.selectCustomerDataTableOptions,
}
